import { Component, Input } from "@angular/core";
import { Router } from "@angular/router";
import { TypeEventOperationHistory } from "@edp-enums/type-event-operation.enum";
import { SelectedComponentEnum } from "@edp-models/edp-payment-agreement.model";
import { EdpUser } from "@edp-models/user.model";
import { NewModalService } from "@edp-pages/requests-and-operations/services/new-modal.service";
import { EdpPaymentAgreementService } from "@edp-services/edp-payment-agreement.service";
import { EdpSteperService } from "@edp-services/edp-steper.service";
import { EdpRecaptchaService } from "@edp-services/edpRecaptchaService.service";
import { PaymentService } from "@edp-services/payment.service";
import { getUser } from "@edp-store/selectors/user.selectors";
import { IAppState } from "@edp-store/state/app.state";
import { Store } from "@ngrx/store";

@Component({
    selector: "agreement-expired",
    templateUrl: "./agreement-expired.component.html",
    styleUrls: ["./agreement-expired.component.scss"],
})
export class AgreementExpiredComponent {
    @Input() redirectUrl: string;
    
    public recaptchaToken: string;
    public recaptcha: any;
    public isPage: boolean;
    public user: EdpUser 

    constructor(
        private router: Router,
        private edpPaymentAgreementService: EdpPaymentAgreementService,
        private steperService: EdpSteperService,
        private recaptchaService: EdpRecaptchaService,
        private readonly modalService: NewModalService,
        private paymentService: PaymentService, 
        private readonly store: Store<IAppState>,
    ) {
        this.isPage = this.edpPaymentAgreementService.getBottomBarValue();
        this.store.select(getUser).subscribe(user => {
            this.user = user
        });
    }

    public close() {
        if(this.redirectUrl) {
            this.router.navigate([this.redirectUrl]);
        } else {
            this.redirect();
        }
    }

    public redirect() {
        if (this.user) {
            this.goToRequestAndOperations();
        } else {
            this.gotToStepOne();
        }
    }

    public goToRequestAndOperations() {
        this.modalService.closeModal();
    }

    public gotToStepOne() {
        this.steperService.setActiveStep(1);
        this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.PERSONAL);
    }

    public goToStepTwo() {
        this.steperService.setActiveStep(2);
        this.edpPaymentAgreementService.setSelectedComponent(SelectedComponentEnum.ELIGIBILITY);
    }

    public onAgreementGenerate(captchaRef: any): void {
        captchaRef.execute();
        this.recaptcha = captchaRef;
        this.setOperationHistory(TypeEventOperationHistory.NEWREQUESTAGREEMENTEXPIRED);
    }

    public resolved(captchaResponse: string): void {
        this.recaptchaToken = captchaResponse;
        this.recaptchaService.setContactResponse(this.recaptchaToken);
        if (this.recaptchaToken) {
            this.goToStepTwo();
        }
    }

    private setOperationHistory(operation: string) {
        this.paymentService.agreementHistory({ operation }).subscribe(() => {});
    }
}
